import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BrandConfig } from "@/lib/brand-config";

interface BrandState {
	config: BrandConfig;
	product: string;
}

const initialState: BrandState = {
	config: {
		name: "ARC",
		logo: "/arc-logo.png",
		primaryColor: "#da291c",
		hoverColor: "#b82318",
		textColor: "#da291c",
	},
	product: "arc",
};

const brandSlice = createSlice({
	name: "brand",
	initialState,
	reducers: {
		setBrandConfig: (state, action: PayloadAction<BrandConfig>) => {
			state.config = action.payload;
		},
		setProduct: (state, action: PayloadAction<string>) => {
			state.product = action.payload;
		},
	},
});

export const { setBrandConfig, setProduct } = brandSlice.actions;
export default brandSlice.reducer;
